import React from 'react';
import { fname } from "../utils.js";

// ─────────────────────────────────────────────────────────────────────────────
// SecAnomaliesSync — journal des anomalies de synchronisation (décision Claire du
// 29/07/2026, voir HANDOFF). Source = clé syncano7, alimentée par SyncErrorBanner
// (GerantClientUI.jsx) : une entrée n'apparaît QUE si un salarié a quitté/rechargé
// l'appli pendant un échec de sync Supabase non résolu — jamais pour un échec qui
// s'est corrigé tout seul (append-only, pas de suppression : sert de preuve).
//
// Usage prévu : vérifier si un bandeau d'anomalie a réellement été affiché à un
// salarié qui affirme avoir soumis un rapport/contrôle que Claire ne voit pas.
// ─────────────────────────────────────────────────────────────────────────────

const KEY_LABELS={
  controles7:'Contrôle',
  rep7:'Rapport',
  als7:'Pointage',
  assist7:"Demande d'aide",
  st7:'Tâches',
  sejours7:'Séjours',
  objets7:'Objets trouvés',
  factures7:'Facturation',
  statutAppts7:'Statut appartements',
  commentaires8:'Commentaires',
  filPartage7:'Fil de partage',
  filProprio7:'Fil propriétaire',
};
const labelKey=k=>KEY_LABELS[k]||k;

const fmtDt=ts=>{
  if(!ts)return '?';
  try{return new Date(ts).toLocaleString('fr-FR',{day:'2-digit',month:'2-digit',year:'2-digit',hour:'2-digit',minute:'2-digit'});}
  catch(_){return '?';}
};

const resolveName=(entry,staff,gerants)=>{
  if(entry.name)return entry.name;
  if(entry.sessType==='staff'){const s=(staff||[]).find(x=>x.id===entry.sessId);return s?fname(s):'Salarié inconnu';}
  if(entry.sessType==='gerant'){const g=(gerants||[]).find(x=>x.id===entry.sessId);return g?.name||'Direction';}
  if(entry.sessType==='admin')return 'Admin';
  return entry.sessType||'Inconnu';
};

export function SecAnomaliesSync({syncano,staff,gerants}){
  const list=[...(syncano||[])].sort((a,b)=>(b.lastTs||0)-(a.lastTs||0));
  return(<div style={{padding:'16px'}}>
    <div className="D" style={{fontSize:18,marginBottom:4}}>⚠️ Anomalies de synchronisation</div>
    <div style={{fontSize:12,color:'var(--si)',marginBottom:16,maxWidth:640}}>
      Recense automatiquement les cas où un salarié a quitté ou rechargé l'appli pendant qu'une
      écriture ou lecture Supabase était encore en échec (bandeau rouge affiché, non résolu à
      son départ). Un incident résolu tout seul avant que le salarié ne parte n'apparaît jamais
      ici. Utile pour vérifier si un bandeau a réellement pu être vu par tel salarié à tel moment.
    </div>
    {list.length===0&&<div className="empty">Aucune anomalie non résolue enregistrée. 👍</div>}
    {list.map(e=>(
      <div key={e.id} style={{background:'#fff',border:'1px solid var(--li)',borderLeft:'4px solid #ef4444',borderRadius:8,padding:'10px 14px',marginBottom:8}}>
        <div style={{display:'flex',justifyContent:'space-between',flexWrap:'wrap',gap:8}}>
          <div style={{fontWeight:700,fontSize:13}}>{resolveName(e,staff,gerants)}</div>
          <div style={{fontSize:11,color:'var(--si)'}}>{fmtDt(e.firstTs)} → {fmtDt(e.lastTs)}</div>
        </div>
        <div style={{fontSize:12,marginTop:4}}>
          {Object.keys(e.errors||{}).map(k=>(
            <div key={k} style={{fontFamily:'monospace',fontSize:11,lineHeight:1.5}}>
              <strong>{labelKey(k)}</strong> ({k}) · {e.errors[k].op==='write'?'écriture':'lecture'} · {e.errors[k].attempt} tentative(s) · {e.errors[k].message}
            </div>
          ))}
        </div>
      </div>
    ))}
  </div>);
}
